$ = require 'jquery'
PopOver = require 'app/scripts/views/lib/pop-over'
Util = require 'app/scripts/lib/util'
View = require 'app/scripts/views/internal/view'
templates = require 'app/scripts/views/internal/templates'
template = require 'app/scripts/views/templates/popover_confirmation_public_boards'
BoardMemberAddMultipleView = require 'app/scripts/views/board-menu/board-member-add-multiple-view'
{ trackUe } = require '@trello/analytics'
{ featureFlagClient } = require '@trello/feature-flag-client'

module.exports = class ConfirmationPublicBoardsView extends View
  viewTitleKey: 'change to public'

  className: 'confirmation-popover'

  events:
    'click .js-submit': 'selectVis'
    'click .js-action-link': 'renderInvitationLink'

    'mouseenter .js-action-link': 'mouseenter'
    'mouseleave .js-action-link': 'mouseleave'

  render: ->
    data = @model.toJSON()
    data.isTemplate = @model.isTemplate()

    @$el.html template(data)

    @

  selectVis: (e) ->
    Util.stop(e)

    change = if @model.getPref('permissionLevel') != 'public' then 1 else 0

    @model.setPref('permissionLevel', 'public')
    @model.save()

    trackUe('board', 'sets', 'board visibility', '', 'to public', '', { boardid: @model.id, change: change })

    PopOver.hide()

  renderInvitationLink: (e) ->
    Util.stop(e)
    view = new BoardMemberAddMultipleView({ @model, @modelCache })
    view.loadOrgData()
    $('.js-open-manage-board-members').removeClass('open-manage-boards-offset')

    PopOver.toggle
      elem: $('.js-open-manage-board-members')
      view: view
      trackUe('Invitation Link', 'opens', 'Multiple members invite view', '', '', 'by clicking invite link in confirmation view', { boardid: @model.id })

    return

  mouseenter: (e) ->
    $('.js-open-manage-board-members').addClass('open-manage-boards-offset')

  mouseleave: (e) ->
    @setTimeout ->
      $('.js-open-manage-board-members').removeClass('open-manage-boards-offset')
    , 0
